module.exports = __webpack_public_path__ + "assets/img/detail-content-img-3-14172d8a.jpg";